import { BRAND } from "./constants";

// Logo de Rutment (12/10): "rutment" en JetBrains Mono 700 seguido de un bloque
// tipo cursor. FUENTE ÚNICA: ninguna pantalla copia este marcado.
// Proporciones para un tamaño F: bloque ≈ 0.46F × F, radio ≈ 0.08F, hueco ≈ 0.19F.
// La fuente se carga en public/index.html y en el <link> de Google Fonts de App.js.
export const LOGO_FONT = "'JetBrains Mono', SFMono-Regular, Menlo, Consolas, monospace";
export const LOGO_FONT_LINK = "https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@700&display=swap";

// GEMELO de Logo en Layout.jsx del portal: mismas cuentas.
const dims = (size) => ({
  w: Math.round(size * 0.46),
  h: size,
  r: Math.max(1, Math.round(size * 0.08)),
  gap: Math.max(3, Math.round(size * 0.19)),
});

// blink: el bloque parpadea como un cursor (solo en la portada). La animación
// "rt-blink" la define LandingView y se apaga con prefers-reduced-motion.
// cursorClassName: clase extra para animar solo el bloque (el salto del
// cargador de la guía, SimpleGuide.jsx).
export default function Logo({ size = 20, color = BRAND, style, blink = false, cursorClassName }) {
  const d = dims(size);
  return (
    <span aria-label="rutment" role="img" style={{ display: "inline-flex", alignItems: "center", gap: d.gap, lineHeight: 1, verticalAlign: "middle", ...style }}>
      <span style={{ fontFamily: LOGO_FONT, fontWeight: 700, fontSize: size, letterSpacing: "-0.05em", color, lineHeight: 1, textTransform: "none" }}>rutment</span>
      <span className={[blink ? "rt-blink" : "", cursorClassName || ""].join(" ").trim() || undefined} style={{ display: "inline-block", width: d.w, height: d.h, borderRadius: d.r, background: color, flexShrink: 0 }} />
    </span>
  );
}

// Mismo logo como HTML en texto, para las ventanas de impresión / PDF
// (window.open + document.write). La ventana necesita LOGO_FONT_LINK en su <head>.
export function logoHtml(size = 20, color = "#3E3EF8") {
  const d = dims(size);
  return `<span style="display:inline-flex;align-items:center;gap:${d.gap}px;line-height:1;vertical-align:middle;"><span style="font-family:${LOGO_FONT};font-weight:700;font-size:${size}px;letter-spacing:-0.05em;color:${color};line-height:1;">rutment</span><span style="display:inline-block;width:${d.w}px;height:${d.h}px;border-radius:${d.r}px;background:${color};"></span></span>`;
}
